import http from './http'

// Endpoint paths are centralized here; adjust when the PHP API is finalized.
export function login(credentials) {
  return http.post('api/auth/login', credentials)
}

export function fetchCurrentUser() {
  return http.get('api/auth/me')
}

export function logout() {
  return http.post('api/auth/logout')
}

// Update the signed-in user's own name/avatar.
export function updateProfile(payload) {
  return http.put('api/auth/me', payload)
}

// Change the signed-in user's own password.
export function changePassword(payload) {
  return http.post('api/auth/change-password', payload)
}

// Request a password-reset email (always resolves; backend never leaks whether
// the address exists).
export function requestPasswordReset(email) {
  return http.post('api/auth/forgot-password', { email })
}

// Complete a reset with the emailed token. Payload: { token, new_password }
export function resetPassword(payload) {
  return http.post('api/auth/reset-password', payload)
}
